module.exports = __webpack_public_path__ + "img/Ellipse11.a550d184.png";